import { UserButton, useAuth } from "@clerk/clerk-react";
import { Link, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAppAuth } from "./contexts/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import RunDetailPage from "./pages/RunDetailPage";
import SettingsPage from "./pages/SettingsPage";

function Nav() {
  const { isSignedIn } = useAuth();
  const { appUser } = useAppAuth();
  if (!isSignedIn || appUser?.status !== "ok") return null;
  return (
    <header className="nav">
      <div className="nav-links">
        <Link to="/">Dashboard</Link>
        {appUser.role === "admin" && <Link to="/settings">Settings</Link>}
      </div>
      <UserButton />
    </header>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Nav />
      <main>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/runs/:id"
            element={
              <ProtectedRoute>
                <RunDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute requireAdmin>
                <SettingsPage />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </AuthProvider>
  );
}
